export default "__VITE_ASSET__D2R1HWiS__"